import React, { useState } from "react";
import { Form, Input, notification } from "antd";
import fetchApi from "../../../api-services/apiIndex"; 
import "react-phone-input-2/lib/style.css";
import PhoneNumber from "../../clientdashboard/FormElements/PhoneNumber";
import { Button } from "react-bootstrap";
import Layout from "../../../common_comp/Layout/Layout";
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_SITE_KEY = "6LcAMgorAAAAAOR8wgBCyULPfpNc6wtwHI3BF2TW"; // 🔁 Replace with your site key

export default function ContactForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleSubmit = async (formValues) => {
    if (!captchaValue) {
      notification.error({ message: "Please verify the CAPTCHA" });
      return;
    }

    setLoading(true);
    const values = {
      ...formValues,
      phone: formValues.phone.num,
    //   recaptchaToken: captchaValue, // optional, in case your backend validates it
    };

    const formData = new FormData();
    for (const key in values) {
      formData.append(key, values[key]);
    }

    const res = await fetchApi.post("CONTACTUS", formData);
    if (res?.status === 200) {
      notification.success({
        message:
          "Your details have been submitted successfully. Our team will contact you shortly.",
      });
      form.resetFields();
      setCaptchaValue(null); // Reset captcha
    } else {
      notification.error({ message: "Failed! Try again." });
    }
    setLoading(false);
  };

  return (
    <Layout>
      <div className="pb-2 max-w-container container flex-col-2 mt-5">
        <h1 className="mb-3 jab_commmon_color">Contact Our Team</h1>
        <Form
          form={form}
          layout="vertical"
          validateMessages={{
            required: "${label} is required",
          }}
          scrollToFirstError
          requiredMark={(label, info) => (
            <div className="form-label">
              {label}{" "}
              {info.required && <span style={{ color: "var(--error)" }}>*</span>}
            </div>
          )}
          onFinish={handleSubmit}
        >
          <Form.Item label="Name" name="name" rules={[{ required: true }]}>
            <Input placeholder="Enter your Name" />
          </Form.Item>

          <Form.Item
            label="E-mail"
            name="emailId"
            rules={[
              { required: true, message: "" },
              {
                validator: (_, value) => {
                  if (
                    value &&
                    value.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z]+\.[a-zA-Z]{2,}$/)
                  ) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Please enter a valid email")
                  );
                },
              },
            ]}
          >
            <Input placeholder="Enter your Email" />
          </Form.Item>

          <Form.Item
            label="Phone"
            name="phone"
            rules={[
              { required: true, message: "" },
              {
                validator: (_, value) => {
                  if (value && !value?.error) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Please enter a valid phone number")
                  );
                },
              },
            ]}
          >
            <PhoneNumber />
          </Form.Item>

          <Form.Item label="Message" name="message">
            <Input.TextArea rows={4} placeholder="Write Message to Editor" />
          </Form.Item>

          {/* ✅ reCAPTCHA component */}
          <div className="mb-3">
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              onChange={(value) => setCaptchaValue(value)}
              theme="light"
            />
          </div>

          <Button type="submit" disabled={loading} className="jab_commonbtn">
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </Form>
      </div>
    </Layout>
  );
}
